import UIComponent from "sap/ui/core/UIComponent";
import RouteServices from "niteroi/services/RouteServices";

/**
 * Sales & Distribution Component
 *
 * @namespace niteroi.packages.sales-distribution
 */
export default class Component extends UIComponent {
    public static metadata = {
        interfaces: ["sap.ui.core.IAsyncContentCreation"],
        manifest: "json"
    };
    private _routeServices: RouteServices;

    public init(): void {
        super.init();
        if (this.getRouter().isInitialized() === false) {
            this._routeServices = new RouteServices(this);
        }
    }

    public getRouteServices(): RouteServices | undefined {
        return this._routeServices;
    }
}
